/**
 * AB Test Features Constants
 * Centralized location for all AB test feature names to avoid typos and ensure consistency
 */
export enum AbFeatures {
  NEW_LEAD_DETAILS_PAGE_V1 = 'new_lead_details_page_v1',
  LEAD_ACTIVITY_SUMMARIES_V1 = 'lead_activity_summaries_v1',
  ORG_FILTERS_V1 = 'org_filters_v1',
  HOT_LEAD_BADGE = 'hot_lead_badge_v1',
  ACTIVITY_SUMMARY_AI = 'activity_summary_ai',
  ENABLE_ACTIVITY_LIST_VIEW_SEGMENT_CONTROL = 'enable_activity_list_view_segment_control',
  TELEPHONY_ENABLED = 'telephony_enabled',
  LEAD_PHONE_VISIBLE = 'lead_phone_visible',
  NEW_GENERATE_BROCHURE_BUTTON = 'new_generate_brochure_button',
  CRM_GUIDE = 'crm_guide',
  NOTIFICATION_CENTER = 'notification_center',
  AI_CALL_LEAD_TRIGGER = 'ai_call_lead_trigger',
  AI_CALL_BULK_TRIGGER = 'ai_call_bulk_trigger',
  // Add more AB test features here as they are introduced
}
